import * as yup from "yup";
import { validateDate, validateTimeNotInFuture } from "../datetime";

// Define the validation schema using yup
export const customerInteractionSchema = yup.object().shape({
  interactionTime: yup
    .string()
    .required("Time is required")
    .test("not-in-future", "Time cannot be in the future", function (time) {
      const { interactionDate } = this.parent;
      return validateTimeNotInFuture(time, interactionDate);
    }),

  searchedCustomer: yup.string().notRequired(),
  customer: yup.object().required("Selected customer is required"),

  isCustomerVulnerable: yup.boolean(),
  isCustomerOk: yup.boolean(),
  customerUnknown: yup.boolean(),

  reason: yup.number("Please select a reason").when("isCustomerVulnerable", {
    is: true,
    then: (schema) => schema.required("Reason for interaction is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  outcome: yup.number("Please select an outcome").when("isCustomerVulnerable", {
    is: true,
    then: (schema) => schema.required("Outcome is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  otherOutcome: yup.string().when("outcome", {
    is: (outcome) => outcome === 4,
    then: (schema) => schema.required("Outcome description is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  actionTaken: yup
    .number("Please select an action")
    .when("isCustomerVulnerable", {
      is: true,
      then: (schema) => schema.required("Action is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  isVulnerable: yup.boolean().when("isCustomerVulnerable", {
    is: true,
    then: (schema) =>
      schema.required(
        "Please specify whether or you want to flag the customer as vulnerable.",
      ),
    otherwise: (schema) => schema.notRequired(),
  }),

  providedLeaflet: yup.boolean().when("isVulnerable", {
    is: true,
    then: (schema) =>
      schema.required("Please specify whether or not leaflet was provided"),
    otherwise: (schema) => schema.nullable(),
  }),
  reasonNotProvidedLeaflet: yup
    .string()
    .when(["isVulnerable", "providedLeaflet"], {
      is: (x, y) => x && !y,
      then: (schema) =>
        schema.required(
          "Please provide the reason why not provide a safer gambling leaflet?",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

  seekHelp: yup.boolean().when("isVulnerable", {
    is: true,
    then: (schema) =>
      schema.required(
        "Please specify whether or not how to seek help was explained",
      ),
    otherwise: (schema) => schema.nullable(),
  }),
  reasonNotSeekHelp: yup.string().when(["isVulnerable", "seekHelp"], {
    is: (x, y) => x && !y,
    then: (schema) =>
      schema.required(
        "Please provide the reason why not explain how to seek help?",
      ),
    otherwise: (schema) => schema.notRequired(),
  }),

  discussedSelfExclusion: yup.boolean().when("isVulnerable", {
    is: true,
    then: (schema) =>
      schema.required(
        "Please specify whether or not self-exclusion was discussed",
      ),
    otherwise: (schema) => schema.notRequired(),
  }),
  reasonNotDiscussedSelfExclusion: yup
    .string()
    .when(["isVulnerable", "discussedSelfExclusion"], {
      is: (x, y) => x && !y,
      then: (schema) =>
        schema.required(
          "Please provide the reason why not explain self-exclusion process?",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

  selfExclude: yup.boolean().when(["isVulnerable", "discussedSelfExclusion"], {
    is: (x, y) => x && y,
    then: (schema) =>
      schema.required(
        "Please specify whether or not the customer wish to self-exclude",
      ),
    otherwise: (schema) => schema.nullable(),
  }),
  reasonNotSelfExclude: yup
    .string()
    .when(["isVulnerable", "discussedSelfExclusion", "selfExclude"], {
      is: (x, y, z) => x && y && !z,
      then: (schema) =>
        schema.required(
          "Please provide the reason why not wish to self-exclude?",
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

  temporaryBreak: yup
    .boolean()
    .required(
      "Please specify whether or not you want to setup a temporary break for this customer.",
    ),
  returnDate: yup.string().when("temporaryBreak", {
    is: true,
    then: (schema) =>
      schema
        .required("Return date is required")
        .test("is-valid-date", "Return date is not valid", validateDate),
    otherwise: (schema) => schema.nullable(),
  }),

  comments: yup.string().notRequired(),
});
